//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      editButtons: []
    };
  },
  methods: {
    $ready: function $ready() {
      this.editButtons = this.spec.editButtons || [];
    }
  }
};